import{gql as o}from"@apollo/client";const r=o`
  fragment projectThemeFragment on ProjectThemeGraphType {
    backGroundColor
    buttonColor
    customCss
    footerColor
    headerColor
    linkColor
    sideColor
  }
`;export{r as PROJECT_THEME_FRAGMENT};
//# sourceMappingURL=projectTheme.fragment.js.map
